import React from 'react'
import { Link, LinkProps } from 'react-router-dom'

interface CustomLinkProps extends Omit<LinkProps, 'to'> {
  href?: string
  as?: string
  to?: string
}

/**
 * A simple link wrapper component that provides compatibility with different routing patterns.
 * Acts as a bridge between different Link implementations by normalizing href/as/to props.
 *
 * @param href - The primary URL destination (legacy support)
 * @param as - Alternative URL destination (legacy support, takes precedence over href)
 * @param to - React Router v6 destination
 * @param rest - All other props passed through to the underlying Link component
 * @returns A React Router Link component with normalized props
 */
export default ({ href, as, to, ...rest }: CustomLinkProps) => (
  <Link to={to || as || href || '/'} {...rest} />
)
